import { WithGrow } from "@common/components/WithGrow";
import React from "react";
import ActionsPanel from "../ActionsPanel";
import RoleForm from "../RoleForm";

interface RoleContentProps {}

const RoleContent = ({}: RoleContentProps): React.JSX.Element => {
  return (
    <WithGrow
      direction="column"
      fixed={<ActionsPanel />}
      containerSx={{
        overflowY: "scroll",
      }}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.default,
      })}
    >
      <RoleForm />
    </WithGrow>
  );
};

export default RoleContent;
